module.exports = __webpack_public_path__ + "static/media/outro.88858e89.svg";